import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { RecoilRoot } from "recoil";
import { BrowserRouter } from "react-router-dom";
// providers
import { AppContextProvider } from "./providers";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <RecoilRoot>
        <AppContextProvider>
          <App />
        </AppContextProvider>
      </RecoilRoot>
    </BrowserRouter>
  </React.StrictMode>
);
